<template>
  <form ref="anyName">
    <div class="tab-pane" :class="{ active: defaultTab, show: defaultTab }" :id="id">
      <div class="p-4 b-b _600 nav-title">Assign Assessment</div>
      <div role="form" class="col-12 col-lg-12">
        <div v-if="user.role.school_dash_access_level < 2" class="row m-0 pt-4">
          <div class="col-12 form-group">
            <label>Select District</label>
            <v-select v-model="sDistrict" label="name" :options="districts"></v-select>
          </div>
        </div>
        <div v-if="user.role.school_dash_access_level === 2" class="row m-0 pt-4">
          <div class="col-12 form-group">
            <label>Select District</label>
            <v-select v-model="sDistrict" label="name" :options="districts"></v-select>
          </div>
        </div>

        <div v-if="user.role.school_dash_access_level < 2" class="row m-0 pt-4">
          <div class="col-12 form-group">
            <label>Select Courses</label>
            <v-select multiple v-model="sCourses" label="name" :options="courses"></v-select>
          </div>
        </div>
        <div v-if="user.role.school_dash_access_level === 2" class="row m-0 pt-4">
          <div class="col-12 form-group">
            <label>Select Courses</label>
            <v-select
              @input="updateCourses"
              multiple
              v-model="sCourses"
              label="name"
              :options="courses"
            >
              <template slot="option" slot-scope="option">
                <span>{{ option.name }}</span>
                <div
                  v-if="option.number"
                  class="text-muted pb-1"
                  style="line-height: 0.85rem;"
                  v-html="option.number"
                ></div>
              </template>
            </v-select>
          </div>
          <div class="col-12 form-group">
            <label class="md-check">
              <input v-model="classSearchFilterDistrict" type="checkbox" />
              <i class="theme-accent"></i> Filter by District
            </label>
          </div>
        </div>
        <div class="row m-0 pt-4">
          <div class="col-12 form-group">
            <label>Administration Name</label>
            <input type="text" class="form-control" v-model="asmtName" required/>
          </div>
        </div>
        <div class="checkbox form-group row m-0 pt-4 pl-3">
          <label class="md-check pr-4">
            <input v-model="asmtPretest" type="checkbox" />
            <i class="theme-accent"></i> Pre-test
          </label>
          <label class="md-check">
            <input v-model="asmtPosttest" type="checkbox" />
            <i class="theme-accent"></i> Post-test
          </label>
        </div>
        <div class="row m-0 pt-4">
          <div class="col-12">
            <div class="form-group">
              <label>Administration Notes</label>
              <small
                class="form-text text-muted"
              >These notes will be displayed to any user scoring work from this assessment.</small>
              <RichText
                :text.sync="asmtNotes"
                v-if="renderComponent"
                :init="null"
                :options="{ height: 104 }"
              />
            </div>
          </div>
        </div>
        <div class="row m-0 pt-4">
          <div class="col-12">
            <div class="form-group">
              <label>Students Notes</label>
              <small
                class="form-text text-muted"
              >These notes will be displayed to Students when they are uploading their work.</small>
              <RichText
                :text.sync="studentsNotes"
                v-if="renderComponent"
                :init="null"
                :options="{ height: 104  }"
              />
            </div>
          </div>
        </div>
        <div class="row m-0 pt-4">
          <div class="col-12 text-center">
            <button disabled class="btn btn-secondary"  v-if="asmtName == ''" @click="doAssign">Assign</button>
            <button class="btn btn-primary" v-if="asmtName != ''" @click="doAssign">Assign</button>

          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<style scoped>
.margin-overlap {
  margin-right: -2.5rem;
}
</style>

<script>
import EditPane from "@/components/EditPane";
import SaveOptionalModal from "@/components/SaveOptionalModal";
import ConfigSelect from "@/components/ConfigSelect";
import RichText from "@/components/RichText";

import AssessmentService from "@/services/AssessmentService";
import CourseService from "@/services/CourseService";
import DistrictService from "@/services/DistrictService";
import ContentAreaService from "@/services/ContentAreaService";
import GradeService from "@/services/GradeService";
import ValidationService from "@/services/ValidationService";
import Notie from "@/services/NotieService";
import fs from "@/services/FormatService";
import BB from "bluebird";
import Utils from "@/services/Utils";
import draggable from "vuedraggable";
import ConfigItemSearch from "@/components/ConfigItemSearch";

export default {
  name: "AssessmentAssign",

  props: ["user", "id", "assessment", "defaultTab", "valid"],

  components: {
    EditPane,
    SaveOptionalModal,
    ConfigSelect,
    ConfigItemSearch,
    RichText,
    draggable
  },

  data() {
    return {
      fs: fs,
      assessment: {
        district_id: null,
        loaded: 0
      },
      imglink: ["picture", "link"],

      contentAreas: [],
      selectedContentArea: null,
      selectedItem: null,
      originalDesc: "",
      refresh: null,

      grades: [],
      sGrades: [],

      districts: [],
      sDistrict: null,

      courses: [],
      sCourses: [],

      asmtName: "",
      asmtNotes: "",
      studentsNotes: "",
      asmtPretest: false,
      asmtPosttest: false,
      classSearchFilterDistrict: true,

      dirty: false,
      valid: {},
      saveOptModal: false,
      saveOptNext: () => {},
      saveOptCancel: () => {},
      renderComponent: true
    };
  },

  computed: {
    sGradeIDs() {
      return _.map(this.sGrades, "id");
    },

    sCourseIDs() {
      return _.map(this.sCourses, "id");
    },
    sDistrictID() {
      return (this.sDistrict && this.sDistrict.id) || null;
    }
  },

  created() {
    this.initValidation();
    this.loadData();
  },

  watch: {
    sDistrictID(newVal) {
      let oldVal = this.assessment.district_id;
      if (newVal != oldVal) {
        this.assessment.district_id = newVal;
      }
      CourseService.getCourses({
        district_id: this.assessment.district_id
      }).then(r => {
        this.courses = r.data.courses;
      });
    },
    sGradeIDs(newVal) {
      let oldVal = this.assessment.grade_ids;
      if (oldVal == null) {
        oldVal = newVal.slice(0, newVal.length - 1);
      }
      let same = true;
      if (newVal.length == oldVal.length) {
        for (let i = 0; i < newVal.length; i++) {
          if (newVal[i] != oldVal[i]) {
            same = false;
          }
        }
      } else {
        same = false;
      }

      if (!same) {
        this.assessment.grade_ids = newVal;
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    if (this.dirty) {
      this.saveOptNext = () => {
        next();
      };
      this.saveOptCancel = () => {
        next(false);
      };
      this.saveOptModal = true;
    } else {
      next();
    }
  },

  methods: {
    forceRerender() {
      // Remove my-component from the DOM

      this.renderComponent = false;
      this.$nextTick(() => {
        // Add the component back in
        this.renderComponent = true;
      });
    },
    clearForm() {
      this.forceRerender();
      (this.selectedItem = null),
        (this.originalDesc = ""),
        (this.refresh = null),
        (this.sDistrict = null),
        (this.sDistrict = null),
        (this.assessment = {
          district_id: null,
          loaded: 0
        }),
        (this.courses = []),
        (this.sCourses = []),
        (this.asmtNotes = ""),
        (this.studentsNotes = ""),
        (this.asmtName = ""),
        (this.asmtPretest = false),
        (this.asmtPosttest = false),
        (this.classSearchFilterDistrict = true);
    },

    initValidation() {
      this.valid = ValidationService.newValidator({
        name: {
          group: "details",
          errorMsg: "You must assign a name",
          func: () => {
            return (
              this.assessment &&
              this.assessment.name &&
              this.assessment.name != ""
            );
          }
        },
        ref: {
          group: "details",
          errorMsg: "You must assign a reference ID",
          func: () => {
            return (
              this.assessment &&
              this.assessment.ref_id &&
              this.assessment.ref_id != ""
            );
          }
        },
        ref_char: {
          group: "details",
          errorMsg:
            "Reference IDs may not contain spaces or any of the following characters: ! # % ^ * ( )  / [ ] { } < > ? | ' \" :",
          func: () => {
            return (
              this.assessment &&
              this.assessment.ref_id &&
              fs.isGoodRefID(this.assessment.ref_id)
            );
          }
        }
      });
    },
    listNames(objects, title) {
      if (objects && objects.length > 0) {
        let nameList = `${title}:<br /><br /><ul class='pl-4 pr-3'>`;
        _.each(objects, object => {
          nameList += `<li style="text-align: left;">${object.name}</li>`;
        });

        return nameList + "</ul>";
      } else {
        return "";
      }
    },
    loadData() {
      // CourseService.getCourses().then(r => {
      //   this.courses = r.data.courses;
      // });
      DistrictService.listDistricts().then(r => {
        this.districts = r.data.districts;
        console.log(this.districts);
      });
    },

    blankAssessment() {
      return {
        loaded: 0
      };
    },

    watchChanges() {
      if (this.unwatch) {
        this.unwatch();
      }
      this.unwatch = this.$watch(
        "assessment",
        (newc, old) => {
          this.dirty = true;
        },
        { deep: true }
      );
    },

    updateContentAreaID(contentArea) {
      this.assessment.content_area_id = (contentArea && contentArea.id) || "";
    },

    saveAssessment() {
      return AssessmentService.saveAssessment(this.assessment)
        .then(resp => {
          Notie.info("Assessment Saved");
          if (this.assessment.id != resp.data.id) {
            this.$router.replace("/assessments/" + resp.data.id);
          }
          this.loadData();
        })
        .catch(err => {
          console.log(err);
          Notie.error("Failed to save assessment", err);
        });
    },

    addItem() {
      this.assessment.assessment_items.push({
        sequence: this.assessment.assessment_items.length + 1,
        item_id: this.selectedItem.id,
        item: this.selectedItem
      });
      this.dirty = true;
    },

    itemsSorted() {
      var seq = 1;
      _.each(this.assessment.assessment_items, ai => {
        ai.sequence = seq;
        seq++;
      });
    },

    canSave() {
      return this.dirty;
    },

    doAssign() {
      let delivery = {
        assessment_id: this.assessment.id,
        name: this.asmtName,
        item_notes: this.asmtNotes,
        students_notes: this.studentsNotes,
        pretest: this.asmtPretest,
        posttest: this.asmtPosttest
      };

      for (let i = 0; i < this.sCourses.length; i++) {
        CourseService.assignAssessmentToClasses(this.sCourses[i].id, delivery)
          .then(resp => {
            if (this.sCourses.length == 1 && resp.data.success == 0) {
              Notie.info(
                "Could not create assignment",
                "No classes found matching the specified course(s)"
              );
            } else {
              this.$emit("assigned", "Assigned to courses");

              Notie.success("Assigned to courses");
            }
            this.clearForm();
          })
          .catch(err => {
            console.log(err);
            Notie.error("Failed to assign assessment", err);
          });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/assessment/AssessmentAssign.vue